<template>
  <div class="all-whole">
    <navCom :navActive="navActive"></navCom>
    <div class="w clearfix">
      <!--左侧导航 start-->
      <user-nav :userNav="userNav"></user-nav>
      <!--左侧导航 end-->
      <!--右侧内容 start-->
      <div class="user-main-right">
        <h3 class="info-title">资料下载</h3>
        <ul class="timetable-list">
          <li v-for="(item,index) of down" :key="item.title">
            <a :href="item.file_oss" download="fff" target="_blank" style="display:flex;width: 100%;">
              <div style="display: flex;align-items: center; width: 80%;overflow: hidden;">
                <div class="timetable-list-img"><img src="../../../static/images/syy-images/pdf.png" alt=""></div>
                <span class="syy-download" >{{item.title}}</span>
              </div>
              <span style="color: #b5b5b5;font-size: 14px;width: 20%;text-align: right">{{item.file_size}}  M</span>
            </a>
          </li>
        </ul>

      </div>
      <!--右侧内容 end-->
    </div>
    <footerCom></footerCom>
  </div>
</template>

<script>
  import UserNav from '.././components/user-nav.vue'
  import navCom from '../../components/welcome-nav'
  import footerCom from '../../components/foot'
  import tool from '../../assets/js/tool'
  import pdf from 'vue-pdf'
  import axios from 'axios'

  export default {
    name: 'user-down',
    data() {
      return {
        navActive: 3,
        userNav: 11,
        down: Array,
      }
    },
    components: {
      UserNav,
      navCom,
      footerCom
    },
    methods: {
      getDown() {
        let data = {
          user_id: this.$store.state.uuid,
        };
        tool.postData('Center_Download/index', data, (res) => {
          this.down = res.data.data
        })
      },
    },
    mounted() {
      this.getDown()
    }
  }
</script>

<style scoped>
  .w {
    width: 1200px;
    margin: 0 auto;
  }

  .fl {
    float: left;
  }

  .fr {
    float: right;
  }

  .all-whole {
    background: #f4f4f4;
  }

  .timetable-list-img {
    width: 27px;
    height: 25px;
  }

  .timetable-list-img img {
    width: 100%;
    height: 100%;
    display: block;
  }

  .timetable-list .syy-download {
    font-size: 16px;
    color: #1970ff;
    padding-left: 16px;
  }

  .timetable-list {
    margin-top: 9px;
  }

  .timetable-list li {
    border-bottom: 1px solid #e3e3e3;
    cursor: pointer;
    width: 954px;
    height: 51px;
    line-height: 51px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .user-main-right {
    width: 1000px;
    float: right;
    height: 720px;
    background: #ffffff;
  }

  .nickname ::-webkit-input-placeholder { /* WebKit browsers */
    color: #d0d0d0;
  }

  .nickname :-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    color: #d0d0d0;
  }

  .nickname ::-moz-placeholder { /* Mozilla Firefox 19+ */
    color: #d0d0d0;
  }

  .nickname :-ms-input-placeholder { /* Internet Explorer 10+ */
    color: #d0d0d0;
  }

  .info-title {
    width: 100%;
    height: 70px;
    line-height: 100px;
    box-sizing: border-box;
    border-bottom: 1px solid #e3e3e3;
    font-size: 18px;
    color: #252525;
    padding-left: 20px;
    font-weight: 500;
  }

  .info-modify-div {
    margin-top: 30px;
    font-size: 16px;
    line-height: 35px;
  }

  .info-modify-div p {
    color: #fe4444;
    margin-left: 10px;
  }

  .info-modify-txt {
    color: #6c6c6c;
    font-size: 16px;
    width: 160px;
    display: inline-block;
    text-align: right;
  }

  .default-head img {
    width: 100%;
    height: 100%;
  }

  .default-head-info p {
    font-size: 14px;
    color: #fff;
    line-height: 88px;
    text-align: center;
  }

  .default-head-info input {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    width: 88px;
    height: 88px;
    cursor: pointer;
  }

  .nickname {
    width: 308px;
    height: 35px;
    display: inline-block;
  }

  .nickname-input {
    width: 308px;
    height: 35px;
    border: 1px solid #e3e3e3;
    font-size: 14px;
    color: #6c6c6c;
    padding-left: 10px;
    box-sizing: border-box;
  }

  .input-select-div input[type="radio"], .input-select-div input[type="checkbox"] {
    width: 20px;
    height: 20px;
    opacity: 0;
  }

  .input-select-div span {
    margin-left: 10px;
    color: #878787;
    font-size: 16px;
    font-weight: 500;
  }

  .input-select-div label {
    position: absolute;
    left: 5px;
    top: 6px;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    border: 1px solid #999;
  }

  /*设置选中的input的样式*/
  /* + 是兄弟选择器,获取选中后的label元素*/

  .input-select-div input:checked + label::after {
    position: absolute;
    content: "";
    width: 7px;
    height: 7px;
    top: 4px;
    left: 4px;
    background: #ff0100;
    border-radius: 50%;
  }

  .drop-down-item span {
    line-height: 35px;
    color: #6c6c6c;
    font-size: 14px;
    padding-left: 5px;
    box-sizing: border-box;
    width: 126px;
    display: inline-block;
    cursor: pointer;
  }

  .grade-item span {
    width: 289px;
    height: 32px;
  }

  .drop-down-item i {
    border: 6px solid transparent;
    border-top-color: #bfbfbf;
    vertical-align: bottom;
    position: relative;
    top: 2px;
  }

  .drop-down-choose p {
    line-height: 35px;
    font-size: 14px;
    color: #6c6c6c;
    padding-left: 5px;
    box-sizing: border-box;
    cursor: pointer;
  }

  .drop-down-choose p:hover {
    background: #e3e3e3;
  }

  .info-modify-div {
    margin-top: 30px;
    position: relative;
  }

  .info-modify-txt {
    width: 150px;
    text-align: right;
    display: inline-block;
    margin-right: 15px;
  }

  .preservation-btn {
    width: 313px;
    height: 54px;
    background: #1a71ff;
    font-size: 16px;
    color: #fff;
    line-height: 54px;
    text-align: center;
    margin-top: 58px;
    display: inline-block;
    cursor: pointer;
  }

  .nickname .nickname-input-active {
    border-color: #ff0100
  }
</style>



// WEBPACK FOOTER //
// src/pages/user/user-down.vue